var websitedomain = "";
var enablehcaptcha = false;
var disablelgin = false;
var themes = ["base", "dark"];
var defaultTheme = "base";
var enabledPlugins = [];
export {websitedomain, enablehcaptcha, disablelgin, themes, defaultTheme, enabledPlugins};
